export default "__VITE_PUBLIC_ASSET__2c8d9b20__"